import React from "react";

export default function ProductDetailSkeleton() {
    return (
        <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white text-slate-900 animate-pulse">
            <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/95 backdrop-blur-md">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between gap-4">
                    <div className="h-5 w-28 rounded-lg bg-slate-200" />
                    <div className="h-6 w-32 rounded-lg bg-slate-200" />
                    <div className="h-9 w-9 rounded-xl bg-slate-200" />
                </div>
            </header>

            <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
                <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
                    <div className="aspect-square sm:aspect-[4/3] lg:aspect-square rounded-3xl bg-slate-200" />
                    <div className="space-y-4">
                        <div className="flex gap-2">
                            <div className="h-8 w-24 rounded-full bg-slate-200" />
                            <div className="h-8 w-16 rounded-full bg-slate-200" />
                        </div>
                        <div className="h-10 w-4/5 rounded-xl bg-slate-200" />
                        <div className="h-5 w-32 rounded-lg bg-slate-200" />
                        <div className="h-28 w-full rounded-2xl bg-slate-200" />
                        <div className="space-y-2">
                            <div className="h-4 w-full rounded bg-slate-200" />
                            <div className="h-4 w-full rounded bg-slate-200" />
                            <div className="h-4 w-3/4 rounded bg-slate-200" />
                        </div>
                        <div className="flex gap-3 pt-2">
                            <div className="h-12 flex-1 rounded-xl bg-slate-200" />
                            <div className="h-12 w-36 rounded-xl bg-slate-200" />
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
